import { environment } from "../../../environments/environment";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import * as FileSaver from "file-saver";
import { TranslateService } from "@ngx-translate/core";
import { ToastrAlertService } from "./toastrAlert.service";
import { endpointsURL } from "src/app/constants/endpointsURL";
import {
  dynamicsFields,
  camposdisponibles,
} from "src/app/coc/models/dynamicsFields";

@Injectable({
  providedIn: "root",
})
export class CommonService {
  env = environment.env;
  maintenanceMastertablesURL = endpointsURL.maintenanceMastertablesURL;
  constructor(
    private httpClient: HttpClient,
    private translateService: TranslateService,
    private toastrAlertService: ToastrAlertService
  ) {}

  getInitMessage(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.maintenanceMastertablesURL}MensajeInicio/list?asc=true&page=1&size=10`
    );
  }

  getFilesOfDetallePeticiones(
    dpCampo: string,
    dpId: string,
    dpRelease: string,
    esHitorico: string
  ): Observable<any> {
    let params = new HttpParams();
    params = params.append("dpCampo", dpCampo);
    params = params.append("dpId", dpId);
    params = params.append("dpRelease", dpRelease);
    params = params.append("esHistorico", esHitorico);
    return this.httpClient.get(
      `${this.env}/certificateRequest/downloadFileByDetallePeticiones`,
      {
        params: params,
        responseType: "blob",
      }
    );
  }

  b64toBlob(b64Data, contentType = "", sliceSize = 512): any {
    if (!b64Data) {
      let message = this.translateService.instant("messages.uploadEmptyFile");
      this.toastrAlertService.toastrWarning(message);
      return null;
    } else {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: contentType });
      return blob;
    }
  }

  castToBlob(imgBase64) {
    var block = imgBase64.split(";base64,");
    var contentType = block[0].split(":")[1];

    var b64Data = block[1];

    let blob = this.b64toBlob(b64Data, contentType);
    return blob;
  }

  public blobATexto(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsText(blob);
    });
  }

  downloadFile(data, fileName) {
    const blobUrl = window.URL.createObjectURL(data);
    FileSaver.saveAs(blobUrl, fileName);
  }

  findInvalidControls(controls) {
    const invalid = [];
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push({ name: name, errors: controls[name].errors });
      }
    }
    return invalid;
  }

  getValueOfLabelsById(ids: any[]): string {
    let fields: string =
      this.translateService.instant("messages.fieldsError") + "<br/>";

    ids.forEach((element, index) => {
      let error = this.getErrorsOfFieldControl(element);
      error = error == " ()" ? "" : error;
      if (index == ids.length - 1) {
        fields =
          fields +
          document.getElementById(element.name)?.textContent +
          error +
          "<br/>";
      } else {
        fields =
          fields +
          document.getElementById(element.name)?.textContent +
          error +
          ", <br/>";
      }
    });

    return fields;
  }

  getErrorsOfFieldControl(element): string {
    let error = " (";
    let cont = 0;
    for (let key in element.errors) {
      switch (key) {
        case "maxlength":
          error =
            error +
            this.translateService.instant("messages.fieldsErrorMaxLength") +
            element.errors[key].requiredLength +
            " caracteres";
          break;
        case "minlength":
          error =
            error +
            this.translateService.instant("messages.fieldsErrorMinLength1") +
            element.errors[key].requiredLength +
            this.translateService.instant("messages.fieldsErrorMinLength2");
          break;
        case "required":
          error =
            error +
            this.translateService.instant("messages.fieldsErrorRequired");
          break;
        case "pattern":
          error =
            error +
            this.translateService.instant("messages.fieldsErrorPattern");
          break;
        case "max":
          error =
            error +
            this.translateService.instant("messages.maxValueExceded") +
            element.errors[key].max;
          break;
      }
      if (element.errors.length > 1 && cont < element.errors.length - 1) {
        error = error + ",";
      }
      cont++;
    }
    error = error + ")";
    return error;
  }

  public concatFilters(filterTable: string, filterSearch: string): string {
    if (filterSearch === "") {
      return "?" + filterTable;
    } else {
      return "?" + filterSearch + "&" + filterTable;
    }
  }

  public concatThreeFilters(
    filterTable: string,
    filterSearch1: string,
    filterSearch2: string
  ): string {
    if (filterSearch1 === "" && filterSearch2 === "") {
      return "?" + filterTable;
    } else if (filterSearch1 !== "" && filterSearch2 === "") {
      return "?" + filterSearch1 + "&" + filterTable;
    } else if (filterSearch1 === "" && filterSearch2 !== "") {
      return "?" + filterSearch2 + "&" + filterTable;
    } else if (filterSearch1 !== "" && filterSearch2 !== "") {
      return "?" + filterSearch1 + "&" + filterSearch2 + "&" + filterTable;
    }
  }

  public validationRequiredDynamicFields(fields: any[]): boolean {
    let valid = true;
    let text: string = "";
    fields.forEach((e) => {
      if (
        e.camposdisponibles &&
        e.camposdisponibles.ccObligatorio &&
        e.camposdisponibles.ccObligatorio == 1 &&
        !e.dpValor &&
        e.dpValor == ""
      ) {
        if (valid) {
          text = e.dpCampo + " (requerido) <br/>";
        } else {
          text = ", " + e.dpCampo + " (requerido)";
        }
        valid = false;
      }
    });
    if (!valid) {
      this.toastrAlertService.toastrFail(text);
    }

    return valid;
  }
  castingDynamicFields(
    castDynamicsFields: any,
    detallepeticiones: dynamicsFields[]
  ): dynamicsFields[] {
    let dynamicsFieldsCasted: dynamicsFields[] = [];
    castDynamicsFields.forEach((element) => {
      let index = detallepeticiones.findIndex((e) => e.dpCampo == element.id);
      if (index > -1) {
        let camposdisponibles: camposdisponibles = {
          ccObligatorio: null,
          cdId: null,
          cdListadb: element.list ? element.list : null,
          cdLongitud: null,
          cdTexto: null,
          cdTipo: element.type,
        };
        let object: dynamicsFields = {
          dpCampo: element.text,
          dpCampoid: detallepeticiones[index].dpCampo,
          dpDocumentacion: detallepeticiones[index].dpDocumentacion,
          dpFichero: detallepeticiones[index].dpFichero,
          dpId: detallepeticiones[index].dpId,
          dpRelease: detallepeticiones[index].dpRelease,
          dpValor: detallepeticiones[index].dpValor,
          camposdisponibles: camposdisponibles,
        };
        dynamicsFieldsCasted.push(object);
      }
    });
    return dynamicsFieldsCasted;
  }
}
